// extracted by mini-css-extract-plugin
export default {"switchButtonRow":"switchButtonRow_switchButtonRow__aDoj4","switchTitle":"switchButtonRow_switchTitle__kx9zs","switchDescription":"switchButtonRow_switchDescription__xXaqa"};